import * as React from 'react';
import { IconExternaLink12, Responsive } from '@cian/ui-kit';

import * as styles from './Contacts.css';
import { Logo } from '../Logo';
import { Section } from '../Section';
import { Link } from '../Link';
import { ISocial } from '../../types/builder';
import { SocialIcon } from '../SocialIcon';

export interface IContactsProps {
  phoneButton: React.ReactNode;
  callbackButton?: React.ReactNode;
  logo: string;
  name: string;
  fullName: string;
  legalAddress: string;
  inn: string;
  kpp?: string;
  ogrn: string;
  okpo?: string;
  url: string;
  socials?: ISocial[];
}

export const Contacts: React.FC<IContactsProps> = ({
  phoneButton,
  callbackButton,
  logo,
  name,
  fullName,
  legalAddress,
  inn,
  kpp,
  ogrn,
  okpo,
  url,
  socials,
}) => {
  return (
    <Section dataName="Contacts">
      <div className={styles['container']}>
        <div className={styles['content']}>
          <h4 className={styles['name']}>{name}</h4>
          <div className={styles['full-name']}>{fullName}</div>
          <div>{legalAddress}</div>
          <div className={styles['requisites']}>
            <div>ИНН {inn}</div>
            {kpp && <div>КПП {kpp}</div>}
            <div>ОГРН {ogrn}</div>
            {okpo && <div>ОКПО {okpo}</div>}
          </div>
          <div className={styles['links']}>
            {!!socials?.length && (
              <div className={styles['socials']}>
                {socials.map(social => (
                  <Link key={social.type} href={social.url} data-name="CompanySocialLink">
                    <div className={styles['social-icon']}>
                      <SocialIcon type={social.type} />
                    </div>
                  </Link>
                ))}
              </div>
            )}
            {url && (
              <Link href={url} data-name="CompanySiteLink">
                <div className={styles['site']}>
                  <span className={styles['site-title']}>Сайт компании</span>
                  <IconExternaLink12 color="current_color" />
                </div>
              </Link>
            )}
          </div>
          <Responsive desktop>
            <div className={styles['feedback']}>
              {phoneButton}
              {callbackButton}
            </div>
          </Responsive>
        </div>
        <Logo img={logo} size={{ phone: 40, tablet: 56, desktop: 56 }} />
      </div>
    </Section>
  );
};
